import React, { useCallback } from 'react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';

import WMICHOCustomCoverageTerm from '../WMICHOCustomCoverageTerm/WMICHOCustomCoverageTerm';
import WMICHOBusinessPropertyCovDetailView from './WMICHOBusinessPropertyCovDetailView/WMICHOBusinessPropertyCovDetailView';
import messages from './WMICHOBusinessPropertyCov.messages';

import metadata from './WMICHOBusinessPropertyCov.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function WMICHOBusinessPropertyCov(props) {
    const {
        id,
        dwellingVM,
        path,
        onUpdateJobAndCoverage,
        readOnly,
        onValidationChange: parentOnValidate,
        showErrors: parentShowErrors,
    } = props;
    const translator = useTranslator();

    const updateJobAndCoverage = async () => {
        const items = dwellingVM?.businessPropCovItems?.value || [];
        const limitAmount = items.reduce((sum, item) => sum + item.coverageLimit, 0);
        await onUpdateJobAndCoverage(limitAmount, `${path}.terms[0].directValue`);
    };

    const minimumBusinessPersonalPropertyValidCheck = useCallback(
        () => dwellingVM?.businessPropCovItems?.value?.length > 0,
        [dwellingVM]
    );

    const overrideProps = {
        oneItemRequiredMessage: {
            visible: !minimumBusinessPersonalPropertyValidCheck(),
        },
        businessPersonalPropertyCoverageList: {
            id,
            addButtonLabel: messages.addItemButton,
            coverageItemsVM: dwellingVM?.businessPropCovItems,
            detailViewComponent: WMICHOBusinessPropertyCovDetailView,
            dtoType:
                // eslint-disable-next-line no-secrets/no-secrets
                'wmic.edge.ca.capabilities.policyjob.lob.homeownersHOE.coverables.dto.dwelling.BusinessPropCovItemDTO_WMIC',
            dwellingVM,
            onComponentValidation: minimumBusinessPersonalPropertyValidCheck,
            onValidationChange: parentOnValidate,
            onUpdateJobAndCoverage: updateJobAndCoverage,
            readOnly,
            showErrors: parentShowErrors,
            VMData: [
                {
                    headerText: translator(messages.itemDescription),
                    path: 'description',
                },
                {
                    headerText: translator(messages.itemCoverageLimit),
                    path: 'coverageLimit',
                },
            ],
        },
    };

    const resolvers = {
        resolveComponentMap: {
            WMICHOCustomCoverageTerm,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={dwellingVM}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            onValidationChange={parentOnValidate}
            showErrors={parentShowErrors}
        />
    );
}

export default WMICHOBusinessPropertyCov;
